module.exports = __webpack_public_path__ + "media/newstyle/images/third-circle-6e96318491b34d8230e40379918b5c4c.svg";